import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
const InnerPanel = ({ children, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(Flex, { bgColor: tokens.CanvasPrimary200, py: tokens.Spacing03, px: tokens.Spacing04, borderRadius: tokens.BorderRadius02, ...rest }, children));
};
export default InnerPanel;
